import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DualToggleState } from '../../enum/dual-toggle-state.enum';

@Component({
  selector: 'lib-dual-toggle',
  imports: [MatIcon],
  templateUrl: './dual-toggle.component.html',
  standalone: true,
  styleUrl: './dual-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DualToggleComponent {
  selected = input<DualToggleState>(DualToggleState.left);
  readonly left = input.required<string>();
  readonly right = input.required<string>();
  readonly type = input.required<'text' | 'symbol' | 'compact-text'>();
  toggleSelect = output<DualToggleState>();
  protected readonly DualToggleState = DualToggleState;
}
